<template>
  <v-container>
    <v-app-bar app elevate-on-scroll>
      <v-img :src="theme.logoImgUrl"
        contain aspect-ratio="1.2" max-width="400" max-height="40" />
      <v-spacer></v-spacer>

      <v-btn outlined rounded color="primary" dark @click="login">
        Acessar
        <v-icon right dark>mdi-arrow-right</v-icon>
      </v-btn>
    </v-app-bar>

    <v-row>
      <v-col class="headline text-center">Recuperar Senha</v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row>
      <v-col align="center">
        <recover-password-form />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import RecoverPasswordForm from '@/components/recoverPassword/RecoverPasswordForm';

export default {
  data: () => ({}),
  computed: {
    theme() {
      return this.$store.getters['poweredBy/theme'];
    },
  },
  methods: {
    login() {
      this.$router.push({ path: '/login' });
    },
  },
  components: {
    RecoverPasswordForm,
  },
};
</script>
